/**
 * The stamped download for a photo the buyer is looking at. Only photos served through the marking
 * proxy can be saved this way; anything else returns null and no button is shown.
 */
export function savePhotoUrl(src: string | undefined | null): string | null {
  const url = String(src || "").trim();
  if (!url.includes("/catalogue-media/public/")) return null;
  return `${url}${url.includes("?") ? "&" : "?"}download=1`;
}
